// extracted by mini-css-extract-plugin
export default {"form":"PatientStep9_form__1yW6Y"};